import { db } from "../firebaseConfig";
import { collection, addDoc, getDocs, deleteDoc, updateDoc, doc, query, where, writeBatch } from "firebase/firestore";

// Charger tous les vêtements d'un utilisateur depuis Firestore
export const fetchClothes = async (userId) => {
    try {
        const clothesCollection = collection(db, "clothes");
        const q = query(clothesCollection, where("userId", "==", userId));
        const clothesSnapshot = await getDocs(q);
        return clothesSnapshot.docs.map((doc) => ({
            id: doc.id,
            ...doc.data(),
        }));
    } catch (error) {
        console.error("Erreur lors du chargement des vêtements :", error);
        throw error;
    }
};

// Ajouter un vêtement dans Firestore
export const addClothing = async (formData) => {
    try {
        // Validation minimale
        if (!formData.type || !formData.userId) {
            throw new Error("Données manquantes");
        }

        const docRef = await addDoc(collection(db, "clothes"), formData);
        return docRef.id;
    } catch (error) {
        throw new Error("Erreur Firestore : " + error.message);
    }
};

// Mettre à jour un vêtement dans Firestore
export const updateClothing = async (id, formData) => {
    try {
        const clothingDoc = doc(db, "clothes", id);
        await updateDoc(clothingDoc, formData);
    } catch (error) {
        console.error("Erreur lors de la mise à jour du vêtement :", error);
        throw error;
    }
};

// Supprimer un vêtement depuis Firestore
export const deleteClothing = async (id) => {
    try {
        const clothingDoc = doc(db, "clothes", id);
        await deleteDoc(clothingDoc);
    } catch (error) {
        console.error("Erreur lors de la suppression du vêtement :", error);
        throw error;
    }
};

// Met en favori ou non un vêtement dans Firestore
export const toggleFavori = async (id, isFavori) => {
    try {
        const clothingDoc = doc(db, "clothes", id);
        await updateDoc(clothingDoc, { favori: !isFavori });
    } catch (error) {
        console.error("Erreur lors de la mise à jour des favoris :", error);
        throw error;
    }
};

// Supprimer tous les vêtements d'un utilisateur (par lots de 500)
export const deleteAllClothesForUser = async (userId) => {
    try {
        const clothesCollection = collection(db, "clothes");
        const q = query(clothesCollection, where("userId", "==", userId));
        const snapshot = await getDocs(q);
        if (snapshot.empty) return 0;

        let batch = writeBatch(db);
        let ops = 0;
        let count = 0;
        for (const docSnap of snapshot.docs) {
            batch.delete(docSnap.ref);
            ops++;
            count++;
            if (ops >= 490) { // marge de sécurité sous 500
                await batch.commit();
                batch = writeBatch(db);
                ops = 0;
            }
        }
        if (ops > 0) {
            await batch.commit();
        }
        return count;
    } catch (error) {
        console.error("Erreur suppression de tous les vêtements :", error);
        throw error;
    }
};
